import React, { useState } from 'react';
import { User, Fish } from 'lucide-react';

const WelcomeModal = ({ onNameSubmit }) => {
  const [fullName, setFullName] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (fullName.trim()) {
      onNameSubmit(fullName.trim());
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 z-50 flex justify-center items-center p-4">
      <div className="bg-white rounded-3xl shadow-2xl w-full max-w-md p-6 sm:p-8 text-center">
        <div className="w-24 h-24 bg-gradient-to-br from-blue-100 to-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <Fish className="w-12 h-12 text-blue-600" />
        </div>
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4">
          ¡Bienvenido a Del Mar a Tu Mesa!
        </h2>
        <p className="text-gray-600 mb-6">
          Para una experiencia personalizada, por favor, dinos tu nombre completo.
        </p>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="relative">
            <User className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5" />
            <input
              type="text"
              placeholder="Tu Nombre Completo"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              className="w-full pl-10 pr-4 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500/30 focus:border-blue-500"
              required
            />
          </div>
          <button
            type="submit"
            className="w-full bg-gradient-to-r from-blue-500 to-teal-600 text-white py-3 rounded-xl font-semibold text-lg shadow-md hover:from-blue-600 hover:to-teal-700"
          >
            Continuar
          </button>
        </form>
      </div>
    </div>
  );
};

export default WelcomeModal;